import { render, staticRenderFns } from "./DishLayout.vue?vue&type=template&id=515c0bed&scoped=true"
import script from "./DishLayout.vue?vue&type=script&lang=ts"
export * from "./DishLayout.vue?vue&type=script&lang=ts"
import style0 from "./DishLayout.vue?vue&type=style&index=0&id=515c0bed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c0bed",
  null
  
)

export default component.exports